import PropTypes from 'prop-types';
import { pickBy } from 'lodash';
import { AddToCalendarButton } from 'add-to-calendar-button-react';

const AddToCalendarCta = ({ data }) => {
  if (!data) return null;

  const { jsonData } = data;

  const cleanedData = pickBy(jsonData);

  const styling =
    '--btn-background: #E1251B; --btn-text: #fff; --btn-border-radius: 3.125rem; --btn-font-weight: 600; --btn-padding-x: 2.25rem; --btn-padding-y: 0.75rem; --btn-hover-background: #E1251B; --btn-hover-text: #fff; --btn-border: #E1251B';

  return (
    <AddToCalendarButton
      {...cleanedData}
      styleLight={styling}
      styleDark={styling}
      hideBranding="true"
      hideIconButton="true"
      hideCheckmark="true"
      forceOverlay="true"
    />
  );
};

AddToCalendarCta.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default AddToCalendarCta;
